import { Link, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import ThemeToggle from './ThemeToggle.jsx';

const SECTION_LINKS = [
  { id: 'concepto', label: '¿Qué es?' },
  { id: 'modulos', label: 'Módulos' },
  { id: 'plataforma', label: 'Plataforma' },
  { id: 'paraquien', label: '¿Para quién?' },
  { id: 'equipo', label: 'Equipo' },
  { id: 'faq', label: 'Contacto y FAQs' },
];

const SKOOL_URL = 'https://skool.com/randomcollege';

/**
 * variant:
 *  - "landing": full nav with section anchors + login/CTA + theme
 *  - "minimal": logo (links to /) + theme + primary CTA (Coming Soon)
 *  - "bare":    logo (no link) + theme only — no nav, no CTAs (legal pages)
 */
export default function Header({ variant = 'landing' }) {
  const [active, setActive] = useState('');
  const { pathname } = useLocation();

  useEffect(() => {
    if (variant !== 'landing') return;

    function updateActive() {
      let current = '';
      for (const { id } of SECTION_LINKS) {
        const el = document.getElementById(id);
        if (el && el.getBoundingClientRect().top < window.innerHeight * 0.4) {
          current = id;
        }
      }
      setActive(current);
    }
    window.addEventListener('scroll', updateActive, { passive: true });
    updateActive();
    return () => window.removeEventListener('scroll', updateActive);
  }, [variant, pathname]);

  const logo = (
    <img
      src="/assets/logo-color.svg"
      alt="Random College"
      style={{ height: 38, width: 'auto' }}
    />
  );

  return (
    <header className="rc-header">
      <Link to="/" className="rc-logo">
        {logo}
      </Link>

      <nav className="rc-nav-right">
        {variant === 'landing' &&
          SECTION_LINKS.map(({ id, label }, i) => (
            <span key={id} style={{ display: 'contents' }}>
              <a
                href={`#${id}`}
                className={`seclink${active === id ? ' active' : ''}`}
              >
                {label}
              </a>
              {i < SECTION_LINKS.length - 1 && <span className="secdot" />}
            </span>
          ))}

        {variant === 'landing' && (
          <div
            style={{ width: 1, height: 20, background: 'var(--border)', margin: '0 4px' }}
          />
        )}

        <ThemeToggle />

        {variant === 'landing' && (
          <a href={SKOOL_URL} target="_blank" rel="noopener noreferrer" className="btn-ghost">
            Login
          </a>
        )}
        {variant === 'landing' && (
          <a href={SKOOL_URL} target="_blank" rel="noopener noreferrer" className="btn-primary">
            Acceder a Skool →
          </a>
        )}
        {variant !== 'landing' && (
          <span
            className="btn-primary is-disabled"
            aria-disabled="true"
            role="button"
            tabIndex={-1}
            title="Disponible próximamente"
          >
            Acceder a Skool →
          </span>
        )}
      </nav>
    </header>
  );
}
